import React, { useEffect, useState } from "react";
// import CustomButton from "../../../components/CustomButton/CustomButton";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
// const MyWalletsLogo = `${process.env.PUBLIC_URL}/${val.theme}/MyWallets.png`;
import { makeStyles } from "@mui/styles";
import SearchIcon from "@mui/icons-material/Search";
import {
	getLoginBlockList,
	resetGetLoginBlockList
} from "../../redux/actions/getLoginBlockList";
import {

	getCustomerIdAndNameList
} from "../../redux/actions/getCustomerIdAndNameListAction";
import { getUserNameContactSuggestionList } from "../../redux/actions/partnerGetUserNameContactSuggestionAction"
// import Autocomplete, {
// 	createFilterOptions
// } from "@mui/material/lab/Autocomplete";
import Autocomplete from "@mui/lab/Autocomplete";
import { createFilterOptions } from "@mui/material";
import {
	unLockAccount,
	resetGetManualDepositList
} from "../../redux/actions/unLockAccount";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import BackButton from "../../components/BackButton/BackButton";
import Util from "../../validation";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

function UnlockCustomerAccount() {
	const [open, setOpen] = React.useState(false);
	const classes = useStyles();
	const [customerid, setCustomerid] = useState("");
	const [customername, setCustomername] = useState("");

	const [getLoginBlockListArray, setGetLoginBlockListArray] = useState([]);
	//const [getLoginBlockListArray, setGetLoginBlockListArray] = useState(res);
	const [getLoginUnBlockListArray, setgetLoginUnBlockListArray] = useState("");
	const dispatch = useDispatch();
	const [getLoginBlockListStatus, setGetLoginBlockListStatus] = useState(false);
	const [unLockAccountStatus, setUnLockAccountStatus] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	//const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;

	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [page, setPage] = useState(0);

	const getLoginBlockListRes = useSelector(
		({ getLoginBlockList }) => getLoginBlockList
	);
	const getCustomerIdAndNameListRes = useSelector(
		({ getCustomerIdAndNameList }) => getCustomerIdAndNameList
	);
	const getUsernameSuggestionRes = useSelector(
		({ partnerGetUsernameContactSuggestionsLists }) => partnerGetUsernameContactSuggestionsLists
	)
	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleChange = ({ target: { name, value } }) => {
		if (name === "customerid") {
			setCustomerid(value);
			// Util.verifyNumber(value)
			// 	? setCustomerid(value)
			// 	: setCustomerid(customerid);
		}
		if (name === "customername") {
			// setCustomername(value);
			Util.verifyAlphabet(value)
				? setCustomername(value)
				: setCustomername(customername);
		}
	};

	const handleClose = () => {
		setOpen(false);
	};

	const getLoginBlockListRequest = () => {
		setGetLoginBlockListStatus(true);
		setIsLoading(true);
		const getLoginBlockListReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				customerId: customerid.split("-")[0] || "",
				customerName: customername
			}
		};

		return dispatch(getLoginBlockList(getLoginBlockListReq, authToken));
	};

	
	const getLoginBlockListRequestD = () => {
		setGetLoginBlockListStatus(true);
		setIsLoading(true);
		const getLoginBlockListReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				customerId: "",
				customerName: customername
			}
		};

		return dispatch(getLoginBlockList(getLoginBlockListReq, authToken));
	};

		useEffect(() => {
			if (regenerateTokenRes.data.status == "success") {
				getLoginBlockListRequest();
			}
		}, [regenerateTokenRes.data.status]);
	

	useEffect(() => {
		if (getLoginBlockListStatus) {
			if (getLoginBlockListRes.data.status == "Success") {
				setIsLoading(false);
				setGetLoginBlockListArray(
					[].concat(
						getLoginBlockListRes.data.customerMasterDetailsResponseVOList
					)
				);
			}
			if (getLoginBlockListRes.data.status == "failed") {
				NotificationPopups("error", "Failed", getLoginBlockListRes.data.description);
				setIsLoading(false);
				setGetLoginBlockListArray(getLoginBlockListRes.data);
				// setGetLoginBlockListArray(
				//   [].concat(res.customerMasterDetailsResponseVOList)
				// );
			}
			if (getLoginBlockListRes.data.status == "Failed") {
				NotificationPopups("error", "Failed", getLoginBlockListRes.data.description);
				setIsLoading(false);
				setGetLoginBlockListArray(getLoginBlockListRes.data);
				// setGetLoginBlockListArray(
				//   [].concat(res.customerMasterDetailsResponseVOList)
				// );
			}
			if (getLoginBlockListRes.data.status == "Not Found" ||
				getLoginBlockListRes.data.status == "NOT FOUND") {
				NotificationPopups("error", "Failed", getLoginBlockListRes.data.description)
			}
		}
	}, [getLoginBlockListRes.data.status]);

	console.log("getLoginBlockListArray");
	console.log(getLoginBlockListArray);

	const handleClickOpen = (customerId, level) => {
		setCustomerid(customerId);
		unLockAccounts(customerId, level);
	};

	const unLockAccounts = (customerId, level) => {
		setUnLockAccountStatus(true);
		const unLockAccountReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				customerId: customerId,
				userType: level
			}
		};

		return dispatch(unLockAccount(unLockAccountReq, authToken));
	};

	const unLockAccountRes = useSelector(({ unLockAccount }) => unLockAccount);

	useEffect(() => {
		if (unLockAccountStatus) {
			if (unLockAccountRes.data.status == "success") {
				// getLoginBlockListRequest();
				getLoginBlockListRequestD();
				setCustomerid('')
				setgetLoginUnBlockListArray(unLockAccountRes.data.status);
			}
			if (unLockAccountRes.data.status == "failed") {
				setgetLoginUnBlockListArray(unLockAccountRes.data.status);
			}
			setOpen(true);
		}
	}, [unLockAccountRes.data.status]);

	//name autocomplete
	useEffect(() => {
		if (getUsernameSuggestionRes.data.status === "success") {
			console.log("lissttt", getUsernameSuggestionRes.data.list)
		}
	}, [getUsernameSuggestionRes.data.status])


	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			const getUserContactReq = {
				actionCustomerMasterRequestVO: {
					customerMobileOrName: "",
					walletOwnerId: regenerateTokenRes.data.partnerId || ""
				}
			}
			dispatch(getUserNameContactSuggestionList(getUserContactReq, authToken))
			// console.log("userContact", getUserContactReq)
		}
	}, [regenerateTokenRes.data.status])

	const filterOptionsN = (options, { inputValue }) => {
		if (inputValue.length < 3) {
			return [];
		}

		const filteredOptionsNames = options.filter(
			(option) =>

				option.customerMobileOrName && option.customerMobileOrName.includes(inputValue)
		);

		return filteredOptionsNames.slice(0, 20);
	}

	useEffect(() => {
		if (getCustomerIdAndNameListRes.data.status === "success") {
			console.log("lissttt", getCustomerIdAndNameListRes.data.currencyList)
		}
	}, [getCustomerIdAndNameListRes.data.status])

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			const getCustomerIdAndNameReq = {
				loginDetails: {
					walletOwnerId: regenerateTokenRes.data.partnerId || ""
				},
				actionCustomerMasterRequestVO: {
					customerNameOrId: ""
				}
			};

			dispatch(getCustomerIdAndNameList(getCustomerIdAndNameReq, authToken));
		}
	}, [regenerateTokenRes.data.status]);
	const filterOptionsL = (options, { inputValue }) => {
		if (inputValue.length < 3) {
			return [];
		}

		const filterOptionsList = options.filter(
			(option) =>
				option.includes(inputValue) ||
				""
		);

		return filterOptionsList.slice(0, 20);
	}

	return (
		<>
			<Layout>
				<BackButton />
				<Card>
					{/* <BackButton /> */}
					<Grid
						container
						spacing={2}
						style={{
							padding: "20px",
							marginTop: "1rem",
							marginBottom: "1rem",
							gap: "20px"
						}}
					>
						{/* <Grid item xs={12} sm={12} md={4} lg={4}> */}
						{/* <Typography variant="body1" align="justify" gutterBottom={true}>
                Customer ID
              </Typography> */}
						{/* <TextField
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Customer ID"
								// variant="outlined"
								fullWidth={true}
								name="customerid"
								value={customerid || ""}
								onChange={handleChange}
							/>
						</Grid> */}
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<Autocomplete
								id="combo-box-demo"
								options={[].concat(
									getCustomerIdAndNameListRes.data.currencyList || [""]
								)}
								getOptionLabel={(option) => option}
								filterOptions={filterOptionsL}
								renderInput={(params) => (
									<TextField
										autoFocus
										margin="dense"
										id="name"
										label="Customer ID"
										style={{ marginTop: "3px" }}
										// required
										type="tel"
										fullWidth
										{...params}
										value={customerid}
										name="customerid"
										onBlur={handleChange}
										variant="standard"
										sx={{
											"& .MuiInput-underline:before": {
											  borderBottomColor: "gray", // White color for the underline before focus
											},
											"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
											  borderBottomColor: "gray", // White color on hover
											},
											"& .MuiInput-underline:after": {
											  borderBottomColor: "gray", // White color after focus
											},
										  }}
										// InputProps={{
										// 	sx: {
										// 	  "&:before": { borderBottomColor: "gray" }, // before focus
										// 	  "&:after": { borderBottomColor: "gray" },  // after focus
										// 	},
										//   }}
										//   InputLabelProps={{
										// 	sx: { color: 'gray' }, // Optional: if you want the label to be white
										//   }}
									/>
								)}
							/>
						</Grid>
						{/* <Grid item xs={12} sm={12} md={4} lg={4}> */}
						{/* <Typography variant="body1" align="justify" gutterBottom={true}>
                Customer Name
              </Typography> */}
						{/* <TextField
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Customer Name"
								name="customername"
								value={customername || ""}
								onChange={handleChange}
								fullWidth={true}
							/> */}
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<Autocomplete
								id="combo-box-demo"
								options={[].concat(
									getUsernameSuggestionRes.data.list || [""]
								)}
								getOptionLabel={(option) => option.customerMobileOrName}
								filterOptions={filterOptionsN}
								renderInput={(params) => (
									<TextField
										autoFocus
										margin="dense"
										id="name"
										label="Customer Name"
										style={{ marginTop: "3px" }}
										type="text"
										fullWidth
										{...params}
										value={customername || ""}
										name="customername"
										onBlur={handleChange}
										variant="standard"
										InputProps={{
											sx: {
											  "&:before": { borderBottomColor: "gray" }, // before focus
											  "&:after": { borderBottomColor: "gray" },  // after focus
											},
										  }}
										  InputLabelProps={{
											sx: { color: 'gray' }, // Optional: if you want the label to be white
										  }}

									/>
								)}
							/>
						</Grid>

						<Grid item xs={12} sm={12} md={3} lg={3}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={getLoginBlockListRequest}
							>
								Search <SearchIcon />
							</CustomButton>

							{/* <Button
                style={{
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                endIcon={<AiOutlineSearch />}
                variant="contained"
                className="riskRuleButton"
                onClick={getLoginBlockListRequest}
              >
                Search
              </Button> */}
						</Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getLoginBlockListArray.length == undefined ||
					getLoginBlockListArray.status == "Failed" ||
					getLoginBlockListStatus == false ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Customer Locked Account
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									style={{ color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Customer Locked Account
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table
									className={classes.table}
									size="small"
									aria-label="a dense table"
								>
									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Customer Id{" "}
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Customer Name
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Customer Email
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Mobile
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action
											</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{getLoginBlockListArray &&
											[]
												.concat(getLoginBlockListArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row) => (
													<TableRow key={row.customerId}>
														<TableCell
															align="center"
															component="th"
															scope="row"
														>
															{row.customerId}
														</TableCell>
														<TableCell align="center">
															{row.customerName}
														</TableCell>
														<TableCell align="center">
															{row.customerEmail}
														</TableCell>
														<TableCell align="center">
															{row.mobNumber}
														</TableCell>
														<TableCell align="center">
															<CustomButton
																onClick={() =>
																	handleClickOpen(row.customerId, row.level)
																}
															>
																Unlock
															</CustomButton>
														</TableCell>
														{/* <TableCell align="center">{row.isActive}</TableCell> */}
													</TableRow>
												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={getLoginBlockListArray.length}
									rowsPerPage={rowsPerPage}
									page={page}
									onChangePage={handleChangePage}
									onChangeRowsPerPage={handleChangeRowsPerPage}
								/>
							</TableContainer>
						</Grid>
					</Card>
				)}
			</Layout>

			{getLoginUnBlockListArray == "failed" && (
				// <div>
				//   <Dialog open={open} onClose={handleClose}>
				//     <DialogTitle>UnLock Customer Account</DialogTitle>
				//     <DialogContent>
				//       <h3> Unblock Customer Account UnSuccessfully </h3>
				//     </DialogContent>
				//     <DialogActions>
				//       <Button onClick={handleClose}>Cancel</Button>
				//       <Button onClick={handleClose}>Ok</Button>
				//     </DialogActions>
				//   </Dialog>
				// </div>
				<div>
					<Dialog open={open} onClose={handleClose}>
						<DialogContent
							className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h3
								style={{
									margin: "0 20px",
									fontSize: "15px",
									textAlign: "center"
								}}
							>
								Unblock Customer Account UnSuccessfully
							</h3>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
                style={{
                  margin: "10px 0",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                variant="contained"
                onClick={handleClose}
              >
                Ok
              </Button> */}
							<CustomButton
								style={{
									padding: "8px 16px"
								}}
								onClick={handleClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{getLoginUnBlockListArray != "failed" && (
				// <div>
				//   <Dialog open={open} onClose={handleClose}>
				//     <DialogTitle>UnLock Customer Account</DialogTitle>
				//     <DialogContent>
				//       <h3> Unblock Customer Account Successfully </h3>
				//     </DialogContent>
				//     <DialogActions>
				//       <Button onClick={handleClose}>Cancel</Button>
				//       <Button onClick={handleClose}>Ok</Button>
				//     </DialogActions>
				//   </Dialog>
				// </div>
				<div>
					<Dialog open={open} onClose={handleClose}>
						<DialogContent
							className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h3
								style={{ margin: "0", fontSize: "15px", textAlign: "center" }}
							>
								Unblock Customer Account Successfully
							</h3>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
                style={{
                  margin: "10px 0",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                variant="contained"
                onClick={handleClose}
              >
                Ok
              </Button> */}
							<CustomButton
								style={{
									padding: "8px 16px"
								}}
								onClick={handleClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
}

export default UnlockCustomerAccount;
